/**
 * Maps the current URL path to the embedding plugin it belongs to, so RUM
 * sessions can be filtered by integration (Unily, Staffbase, Coyo/Haiilo,
 * iframe) versus the main app.
 *
 * Each embedded plugin loads under a fixed route prefix (see app-routing
 * and the AppRoute enum) and never navigates out to the main app, so a
 * single read of `window.location.pathname` at tenant resolution is
 * reliable. Values are lowercase + hyphenated to comply with Datadog tags.
 *
 * Prefix matching is sufficient because Angular's router only ever produces
 * these prefixes as whole path segments (e.g. `/coyo-plugin/...`), so no
 * real URL starts with a prefix followed by extra non-slash characters.
 *
 * Staffbase has three top-level route prefixes — `/staffbase-plugin`, plus
 * the `/editor` and `/user` surfaces (see app-routing.module.ts, which loads
 * `staffbase-plugin/editor` and `staffbase-plugin/user`) — all of which map
 * to the `staffbase` facet.
 *
 * Pure function (NOT an @Injectable) to avoid the NG0201 DI white-screen.
 */
export function resolvePluginFromPath(path: string): string {
  if (path.startsWith('/iframe-plugin')) {
    return 'iframe';
  }
  if (
    path.startsWith('/staffbase-plugin') ||
    path.startsWith('/editor') ||
    path.startsWith('/user')
  ) {
    return 'staffbase';
  }
  if (path.startsWith('/coyo-plugin')) {
    return 'coyo-haiilo';
  }
  if (path.startsWith('/unily-plugin')) {
    return 'unily';
  }
  return 'app';
}
